import React from "react";
import { Button, Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import StateTemplate from "./StateTemplate";

type Props = {
  onExit: () => void;
  goBack: () => void;
  entityName: string | undefined;
  errorMessage: string | undefined;
};
const ErrorState = ({ onExit, goBack, entityName, errorMessage }: Props) => {
  const defaultErrorMessage = `Please go back and review your selected date range for ${entityName} or exit.`;
  const subTitle = errorMessage ? errorMessage : defaultErrorMessage;
  return (
    <StateTemplate
      title="Something went wrong"
      subTitle={subTitle}
      icon={<Icon type="exclamation-circle" color={Colors.Danger600} size="xx-large" />}
    >
      <Flex flexDirection={"row"} gap={10}>
        <Button variant="neutral" onClick={onExit}>
          Exit
        </Button>
        <Button onClick={goBack}>Go back</Button>
      </Flex>
    </StateTemplate>
  );
};

export default ErrorState;
